import { Tooltip } from '@material-ui/core';
import { getColor } from 'common/constants/_colors';
import Text from 'components/base/Text';
import { resetTooltipStyle } from 'components/Tooltips/helpers';
import TooltipWrapper from 'components/Tooltips/TooltipWrapper';
import mask from 'images/icons/checkmark.png';
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import { getLastLoggedInProviderName } from '../../AuthModals/auth.modals.service';

const ProviderLogo = styled.img`
  width: 2.4rem;
`;

const ProviderWrapper = styled(Flex)`
  border: 1px solid ${getColor('botticelli')};
  border-radius: 6px;
  ${({ disabled }) => {
    if (disabled) {
      return `
        cursor: default;
        opacity: 0.3;
        background-color: ${getColor('zircon')};
      `;
    } else {
      return `
        cursor: pointer;
        &:hover {
          background-color: ${getColor('zircon')};
          border: 1px solid ${getColor('dodgerBlue')};
        }
      `;
    }
  }}
`;

const calcProviderBoxesWrapping = (providersLength = 0) => {
  if (providersLength <= 5) return '';
  return '25rem';
};

const renderProviderBoxes = ({
  providers = {},
  onClick = _.noop,
  tooltip = _.noop,
  disabled = false
}) => (
  <Flex
    direction='row'
    justify='center'
    maxWidth={calcProviderBoxesWrapping(Object.keys(providers).length)}
    wrap='wrap'
    mt='medium'
    gap='1rem'
  >
    {Object.keys(providers).map((providerKey, idx) => {
      const provider = providers[providerKey];
      return (
        <Flex
          data-cy={providerKey}
          key={providerKey}
          position='relative'
          onClick={disabled ? () => {} : () => onClick(provider)}
          direction='column'
          items='center'
          justify='center'
          content='center'
          mb='small'
        >
          <ProviderWrapper
            height='6rem'
            width='6rem'
            direction='row'
            items='center'
            justify='center'
            content='center'
            disabled={disabled}
          >
            <ProviderLogo
              src={provider.logo}
              alt={`Sign in with ${_.capitalize(provider.title)}`}
            />
          </ProviderWrapper>
          {!disabled && tooltip(provider)}
          <Text
            pt='0.7rem'
            size='small'
            color='shuttleGray'
            width='6rem'
            align='center'
          >
            {provider.title.toUpperCase()}
          </Text>
        </Flex>
      );
    })}
  </Flex>
);

const CheckedProvider = styled.img`
  position: absolute;
  right: 0;
  bottom: 1.4rem;
  border: 1px solid #bbc2ff;
  border-radius: 50%;
  width: 0.7rem;
  height: 0.7rem;
  background-color: ${getColor('titanWhite')};
  padding: 6px;

  :hover {
    background-color: #bbc2ff;
  }
`;

export const ProviderBoxesView = ({
  providers = {},
  onProviderClick,
  disabled
}) => {
  return renderProviderBoxes({
    providers,
    onClick: onProviderClick,
    disabled,
    tooltip: provider =>
      getLastLoggedInProviderName() === provider.authIdentity.toLowerCase() ? (
        <Tooltip
          classes={resetTooltipStyle()}
          title={
            <TooltipWrapper padding='x-small'>
              <Text pl='0.5rem' size='small'>
                you previously signed in with {_.capitalize(provider.title)}
              </Text>
            </TooltipWrapper>
          }
        >
          <CheckedProvider src={mask} alt='' />
        </Tooltip>
      ) : null
  });
};
